import { useEffect } from 'react';

// Sperrt das Seiten-Scrollen (body overflow: hidden), solange `active` true ist —
// z.B. während ein UI-sperrendes Overlay (Speichern/Upload) sichtbar ist.
// Stellt den vorherigen overflow-Wert beim Deaktivieren/Unmount wieder her.
export function useScrollLock(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [active]);
}
